import OrganizationFeatureClientPortalNotification from './OrganizationFeatureClientPortalNotification';
import type { IOrganizationFeatureClientPortalNotifications } from './OrganizationFeatureClientPortalNotifications.interface';

export default class OrganizationFeatureClientPortalNotifications
  implements IOrganizationFeatureClientPortalNotifications {
  dealStageChange: OrganizationFeatureClientPortalNotification;
  newNote: OrganizationFeatureClientPortalNotification;
  newFile: OrganizationFeatureClientPortalNotification;
  newDocumentRequest: OrganizationFeatureClientPortalNotification;
  documentRequestDue: OrganizationFeatureClientPortalNotification;
  missingDocumentRequest: OrganizationFeatureClientPortalNotification;

  static build = (data: IOrganizationFeatureClientPortalNotifications) =>
    new OrganizationFeatureClientPortalNotifications(data);
  static blank = () => new OrganizationFeatureClientPortalNotifications();

  /**
   * Constructor
   * @param {IOrganizationFeatureClientPortalNotifications} data
   */
  constructor(data?: IOrganizationFeatureClientPortalNotifications) {
    this.dealStageChange = new OrganizationFeatureClientPortalNotification(
      data?.dealStageChange
    );
    this.newNote = new OrganizationFeatureClientPortalNotification(data?.newNote);
    this.newFile = new OrganizationFeatureClientPortalNotification(data?.newFile);
    this.newDocumentRequest = new OrganizationFeatureClientPortalNotification(
      data?.newDocumentRequest
    );
    this.documentRequestDue = new OrganizationFeatureClientPortalNotification(
      data?.documentRequestDue
    );
    this.missingDocumentRequest = new OrganizationFeatureClientPortalNotification(
      data?.missingDocumentRequest
    );
  }
}
